import React, { FC } from 'react'
import classes from './Container.module.css'
import { Loader } from '../'

type ContainerProps = {
  actions?: JSX.Element
  showLoader?: boolean
}
export const Container: FC<ContainerProps> = ({ children, actions, showLoader }) => {
  return (
    <div className={classes.root}>
      <div className={classes.body}>
        {children}
      </div>
      <div hidden={!actions} className={classes.history}>
        {actions}
      </div>
      <Loader show={showLoader}/>
    </div>
  )
}